import type { ReactNode } from 'react';
import { clsx } from 'clsx';
import './ChatAIMessage.scss';

export type ChatAIMessageDirection = 'incoming' | 'outgoing';

export interface ChatAIMessageProps {
    direction: ChatAIMessageDirection;
    /** Кто и когда написал — имя сообщения для чтения с экрана. */
    author: string;
    sentTime?: string;
    /** Подсказка над временем: полная дата и время. */
    sentTimeTitle?: string;
    /** Аватар слева от входящего сообщения и его подпись. */
    avatar?: ReactNode;
    avatarLabel?: string;
    /** Сбой вместо ответа: красная подложка пузыря. */
    error?: boolean;
    /** Действия в подвале рядом со временем. */
    actions?: ReactNode;
    children: ReactNode;
}

export function ChatAIMessage({
    direction,
    author,
    sentTime,
    sentTimeTitle,
    avatar,
    avatarLabel,
    error = false,
    actions,
    children,
}: ChatAIMessageProps) {
    return (
        <article
            className={clsx('chat-ai-message', `chat-ai-message--${direction}`, error && 'chat-ai-message--error')}
            aria-label={sentTime ? `${author}: ${sentTime}` : author}
        >
            {avatar && (
                <div className="chat-ai-message__avatar" role="img" aria-label={avatarLabel}>
                    {avatar}
                </div>
            )}
            <div className="chat-ai-message__body">
                <div className="chat-ai-message__bubble">{children}</div>
                {(sentTime || actions) && (
                    <div className="chat-ai-message__footer">
                        {sentTime && (
                            <span className="chat-ai-message__time" title={sentTimeTitle}>
                                {sentTime}
                            </span>
                        )}
                        {actions}
                    </div>
                )}
            </div>
        </article>
    );
}
